import { useEffect, useState } from "react";
import { getLatestTransactionList } from "../../../../network/Apiservices";

export const TransactionHandler = () => {
  const [selectedAccount, setSelectedAccount] = useState({});
  const [transactionList, setTransactionList] = useState([]);
  useEffect(() => {}, []);
  const selectAccount = (account: any) => {
    setSelectedAccount(account);
    getLatestTransactionListApiCall(account);
  };

  const getLatestTransactionListApiCall = async (account: any) => {
    let response = await getLatestTransactionList(
      account?.id ? account.id : ""
    );
    if (
      response?.data?.transactions &&
      response?.data?.transactions.length > 0
    ) {
      setTransactionList(response.data.transactions.slice(0, 3));
    }
  };

  return { selectAccount, selectedAccount, transactionList };
};
